import { fromMd, mdStartPixels, untilMd, zIndexAlert, zIndexBackground, zIndexFixed, zIndexForeground, zIndexModal, zIndexPopovers, zIndexSticky, } from '../../constants';
import { baseTypography } from './baseTypography';
import { deprecatedColorThemeConfig } from './deprecatedColors';
import { deprecatedTextThemeConfig } from './deprecatedText';
import { dropdownThemeConfig } from './dropdown';
import { linkThemeConfig } from './link';
import { baseSpacingPixelValue, borderRadius, rowGap, spacing } from './spacing';
import { themeColorsDarkMode } from './themeColorsDarkMode';
import { themeColorsLightMode } from './themeColorsLightMode';
import { themeTypography } from './themeTypography';
export const sharedThemeValues = {
    color: {
        deprecated: deprecatedColorThemeConfig,
        ...themeColorsLightMode,
    },
    device: {
        breakpoint: { md: `${mdStartPixels}px`, mdPixels: mdStartPixels },
        fromMd,
        untilMd,
    },
    dropdown: dropdownThemeConfig,
    dimensions: {
        layout: {
            sidePadding: {
                md: 16,
                sm: 16,
            },
        },
    },
    header: { height: '60px', slideOutOffset: '75vw' },
    baseSpacingPixelValue,
    spacing,
    borderRadius,
    rowGap,
    typography: {
        deprecated: {
            text: deprecatedTextThemeConfig,
            font: {
                weight: { bold: 700, semibold: 600, normal: 500 },
                family: {
                    primary: baseTypography.font.family.sanSerif,
                    editorial: 'Playfair',
                },
            },
            letterSpacing: { primary: '0.3px' },
        },
        ...themeTypography,
    },
    link: linkThemeConfig,
    zIndex: {
        background: -(Math.pow(2, 31) - 1),
        backgroundContent: zIndexBackground,
        page: 0,
        foregroundContent: zIndexForeground,
        sticky: zIndexSticky,
        fixed: zIndexFixed,
        modals: zIndexModal,
        alerts: zIndexAlert,
        popovers: zIndexPopovers,
    },
};
export const defaultLightTheme = {
    ...sharedThemeValues,
    color: {
        deprecated: deprecatedColorThemeConfig,
        ...themeColorsLightMode,
    },
    name: 'light',
};
export const defaultDarkTheme = {
    ...sharedThemeValues,
    color: {
        deprecated: deprecatedColorThemeConfig,
        ...themeColorsDarkMode,
    },
    name: 'dark',
};
//# sourceMappingURL=default.js.map